import React from "react";

const Outcome = ({ formData, handleChange, dtDisplay }) => {
  // 라디오 버튼 전용 핸들러 - 간단한 재클릭 해제 로직
  const handleRadioClick = (e) => {
    const { name, value } = e.target;
    if (formData[name] === value) {
      handleChange({ target: { name, value: "" } });
    } else {
      handleChange({ target: { name, value } });
    }
  };

  // 복사-붙여넣기 자동 포맷팅 핸들러 (Date 전용)
  const handleDatePaste = (e, fieldName) => {
    e.preventDefault(); // 기본 붙여넣기 동작 방지

    const pastedData = e.clipboardData.getData("text");
    const numbers = pastedData.replace(/\D/g, ""); // 숫자만 추출

    if (numbers.length <= 8) {
      // YYYYMMDD 최대 8자리
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };

  // 날짜 자동 포맷팅 onChange 핸들러
  const handleDateChange = (e, fieldName) => {
    const input = e.target.value;

    // 백스페이스 처리
    if (input.length < (dtDisplay(formData[fieldName]) || "").length) {
      handleChange(e);
      return;
    }

    // 숫자만 추출
    const numbers = input.replace(/\D/g, "");

    if (numbers.length <= 8) {
      // YYYYMMDD 최대 8자리
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };

  return (
    <section className="vip-form-section">
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle">6개월 Outcome</h3>

        {/* 6개월 mRS */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">6개월 mRS (mrs_6m)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "0 : No symptoms",
                  "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
                  "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
                  "3 : Moderate disability. Requires some help, but able to walk unassisted",
                  "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted",
                  "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent",
                  "6 : Dead",
                ].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="mrs_6m"
                      value={option}
                      checked={formData.mrs_6m === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 6개월 GOSE */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">6개월 GOSE 점수 (gose_6m)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "1 : Dead",
                  "2 : Vegetative State (VS)",
                  "3 : Lower Severe Disability (Lower SD)",
                  "4 : Upper Severe Disability (Upper SD)",
                  "5 : Lower Moderate Disability (Lower MD)",
                  "6 : Upper Moderate Disability (Upper MD)",
                  "7 : Lower Good Recovery (Lower GR)",
                  "8 : Upper Good Recovery (Upper GR)",
                ].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="gose_6m"
                      value={option}
                      checked={formData.gose_6m === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 6개월 FU 여부 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">6개월 FU 여부 (fu_yn_6m)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes", "Failed"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="fu_yn_6m"
                      value={option}
                      checked={formData.fu_yn_6m === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 6개월 Shunt 수술 여부 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              6개월 Shunt 수술 여부 (shunt_dependency_6m)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes", "Previous shunt (+)"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="shunt_dependency_6m"
                      value={option}
                      checked={formData.shunt_dependency_6m === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              6개월 outcome FU 일자 (fu_d_6m)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="fu_d_6m"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.fu_d_6m)}
                onChange={(e) => handleDateChange(e, "fu_d_6m")}
                onPaste={(e) => handleDatePaste(e, "fu_d_6m")}
              />
            </div>
          </div>
        </div>

        <h3 className="section-subtitle">1년 Outcome</h3>

        {/* 1년 mRS */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">1년 mRS (mrs_12m)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "0 : No symptoms",
                  "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
                  "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
                  "3 : Moderate disability. Requires some help, but able to walk unassisted",
                  "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted",
                  "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent",
                  "6 : Dead",
                ].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="mrs_12m"
                      value={option}
                      checked={formData.mrs_12m === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 1년 GOSE */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">1년 GOSE 점수 (gose_12m)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "1 : Dead",
                  "2 : Vegetative State (VS)",
                  "3 : Lower Severe Disability (Lower SD)",
                  "4 : Upper Severe Disability (Upper SD)",
                  "5 : Lower Moderate Disability (Lower MD)",
                  "6 : Upper Moderate Disability (Upper MD)",
                  "7 : Lower Good Recovery (Lower GR)",
                  "8 : Upper Good Recovery (Upper GR)",
                ].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="gose_12m"
                      value={option}
                      checked={formData.gose_12m === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 12개월 FU 여부 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              12개월 FU 여부 (fu_yn_12m)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes", "Failed"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="fu_yn_12m"
                      value={option}
                      checked={formData.fu_yn_12m === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 1년 Shunt 수술 여부 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              1년 Shunt 수술 여부 (shunt_dependency_12m)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes", "Previous shunt (+)"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="shunt_dependency_12m"
                      value={option}
                      checked={formData.shunt_dependency_12m === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              1년 outcome FU 일자 (fu_d_12m)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="fu_d_12m"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.fu_d_12m)}
                onChange={(e) => handleDateChange(e, "fu_d_12m")}
                onPaste={(e) => handleDatePaste(e, "fu_d_12m")}
              />
            </div>
          </div>
        </div>

        {/* drop out 및 동의 여부 */}

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Drop-out 여부 (drop_out)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="drop_out"
                      value={option}
                      checked={formData.drop_out === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Drop-out 이유 (drop_out_reason)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "Withdrawal of consent",
                  "Lost to follow-up",
                  "Eligibility issue",
                  "Other",
                ].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="drop_out_reason"
                      value={option}
                      checked={formData.drop_out_reason === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">
              Drop-out 이유 Others (drop_out_reason_others)
            </label>
            <div className="input_1col">
              <input
                type="text"
                name="drop_out_reason_others"
                value={formData.drop_out_reason_others || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              동의서 취득 상태 (consent_status)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["Obtained", "Not obtained", "Withdrawal"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="consent_status"
                      value={option}
                      checked={formData.consent_status === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              동의서 취득일자 (consent_date)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="consent_date"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.consent_date)}
                onChange={(e) => handleDateChange(e, "consent_date")}
                onPaste={(e) => handleDatePaste(e, "consent_date")}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              동의서 철회 일자 (동의서 취득 상태가 Withdrawal일때만 작성)
              (consent_withdrawal_date)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="consent_withdrawal_date"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.consent_withdrawal_date)}
                onChange={(e) => handleDateChange(e, "consent_withdrawal_date")}
                onPaste={(e) => handleDatePaste(e, "consent_withdrawal_date")}
              />
            </div>
          </div>

          <div className="block-2column"></div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Blood 검체 채취 여부 (sample_blood)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="sample_blood"
                      value={option}
                      checked={formData.sample_blood === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              CSF 검체 채취 여부 (sample_csf)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="sample_csf"
                      value={option}
                      checked={formData.sample_csf === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Final Completion status (Final_status)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["Not started", "In process", "Complete"].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="Final_status"
                      value={option}
                      checked={formData.Final_status === option}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Outcome;
